import WithLoadable from '../../components/WithLoadable';

export default WithLoadable(() => import(/* webpackChunkName: "not-found-page" */ './index'));
